module.exports = __webpack_public_path__ + "static/media/bg.2772c0dc.jpg";